import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => {
  const msg = err instanceof Error ? err.message : String(err);
  console.error('[Radiopharm] Bootstrap failed', msg);
});
